<template>
  <q-card flat class="q-pa-md">
    <div
      class="text-h6 text-bold q-px-sm"
      :class="$q.dark.mode ? '' : 'text-primary '"
    >
      <span class="q-mr-xs">{{ bullishOrBearish }} Divergence Signals</span>
      <HelpComponent :helpUrl="'https://youtu.be/7HAs2txrKpI?feature=shared'" />

      <p class="text-caption text-bold">
        As of : {{ store.state.market.asOf }}
      </p>
    </div>

    <div v-if="!store.state.authenticate.isAuthenticated">
      <MessageCard
        :displayMessage="'This feature is only available for logged-in users. Please log in to access it.'"
        :buttonText="'Login'"
        :buttonRoute="'/login'"
        :buttonQuery="'Divergence'"
      />
    </div>
    <div v-else>
      <div v-if="store.state.packages.packageStatus?.current_package == null">
        <MessageCard
          :displayMessage="'This feature is only avilable for paid subscribers. Please subscribe the package'"
          :buttonText="'Subscribe Now'"
          :buttonRoute="'/payment'"
        />
      </div>

      <div
        v-if="
          store.state.packages.packageStatus?.current_package?.features?.includes(
            'is_divergence_signal'
          ) ||
          store.state.packages.packageStatus?.current_package
            ?.daily_signals_expired_status == false ||
          (store.state.packages.packageStatus?.extra_addon?.feature ==
            'DIVERGENCE_SIGNAL' &&
            store.state.packages.packageStatus?.extra_addon?.is_expired ==
              false) ||
          store.state.packages.packageStatus?.extra_permissions?.includes(
            'DIVERGENCE_SIGNAL'
          )
        "
      >
        <div
          v-if="
            store.state.packages.packageStatus?.current_package?.expired_status
          "
        >
          <MessageCard
            :displayMessage="`Your ${store.state.packages.packageStatus?.current_package?.package_name} has expired. Please contact for extension`"
            :buttonText="'Subscribe Now'"
            :buttonRoute="'/payment'"
          />
        </div>
        <q-card flat bordered v-else>
          <div class="q-pa-md">
            <q-radio
              keep-color
              dense
              color="teal"
              v-model="rsiOrMacd"
              val="rsi"
              :label="'RSI'"
            >
              <q-tooltip> Relative Strength Index </q-tooltip>
            </q-radio>
            <q-radio
              class="q-ml-md"
              keep-color
              dense
              color="teal"
              v-model="rsiOrMacd"
              val="macd"
              :label="'MACD'"
            >
              <q-tooltip> Moving Average Convergence/Divergence </q-tooltip>
            </q-radio>
          </div>
          <div class="q-gutter-xs">
            <div class="q-gutter-xs row">
              <q-select
                class="col-md-3 col-xs-12"
                v-model="buttonBuyOrSell"
                dense
                :hint="'Signal Type'"
                label="buy/sell"
                outlined
                :options="['buy', 'sell']"
              ></q-select>
            </div>
            <div class="q-pa-md">
              <q-radio
                keep-color
                dense
                color="teal"
                v-model="divergenceOrHiddenDivergence"
                @click="tab = 'divergence'"
                val="divergence"
                :label="
                  bullishOrBearish == 'Bullish'
                    ? 'Bullish Divergence'
                    : 'Bearish Divergence'
                "
              />
              <q-radio
                keep-color
                class="q-ml-md"
                dense
                color="teal"
                @click="tab = 'divergenceHidden'"
                v-model="divergenceOrHiddenDivergence"
                val="divergenceHidden"
                :label="
                  bullishOrBearish == 'Bullish'
                    ? 'Hidden  Divergence'
                    : 'Hidden Bearish Divergence'
                "
              />
            </div>
          </div>
          <q-tabs
            v-model="tab"
            dense
            inweak-label
            outside-arrows
            mobile-arrows
            :class="$q.dark.mode ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'"
            active-color="white"
            :active-bg-color="$q.dark.mode ? 'grey-9' : 'blue-4'"
            :indicator-color="$q.dark.mode ? 'grey-7' : 'blue-5'"
            align="justify"
            narrow-indicator
          >
            <!-- Start tabs of Bullish Divergence -->
            <q-tab
              v-if="divergenceOrHiddenDivergence == 'divergence'"
              name="divergence"
              :label="
                bullishOrBearish == 'Bullish'
                  ? 'Bullish Divergence Bucket'
                  : 'Bearish Divergence Bucket'
              "
              no-caps
            />

            <q-tab
              v-if="divergenceOrHiddenDivergence == 'divergence'"
              name="divergenceWithPriceActionAlert"
              :label="
                bullishOrBearish == 'Bullish'
                  ? 'Bullish Divergence With Alert Price Action'
                  : 'Bearish Divergence With Alert Price Action'
              "
              no-caps
            />

            <q-tab
              v-if="divergenceOrHiddenDivergence == 'divergence'"
              name="divergenceWithPriceActionSignal"
              :label="
                bullishOrBearish == 'Bullish'
                  ? 'Bullish Divergence  Signal'
                  : 'Bearish Divergence  Signal'
              "
              no-caps
            />
            <!-- End tabs of Bullish Divergence -->

            <!-- Start tabs of Hidden Divergence -->
            <q-tab
              v-if="divergenceOrHiddenDivergence == 'divergenceHidden'"
              name="divergenceHidden"
              :label="
                bullishOrBearish == 'Bullish'
                  ? 'Hidden Divergence Bucket'
                  : 'Hidden Bearish Divergence Bucket'
              "
              no-caps
            />

            <q-tab
              v-if="divergenceOrHiddenDivergence == 'divergenceHidden'"
              name="divergenceWithPriceActionAlertHidden"
              :label="
                bullishOrBearish == 'Bullish'
                  ? 'Hidden  Divergence Alert With Price Action'
                  : 'Hidden Bearish Divergence Alert With Price Action'
              "
              no-caps
            />

            <q-tab
              v-if="divergenceOrHiddenDivergence == 'divergenceHidden'"
              name="divergenceWithPriceActionSignalHidden"
              :label="
                bullishOrBearish == 'Bullish'
                  ? 'Hidden  Divergence  Signal'
                  : 'Hidden Bearish Divergence  Signal'
              "
              no-caps
            />
            <!-- End tabs of Hidden Divergence  -->
          </q-tabs>
          <q-separator></q-separator>
          <q-tab-panels class="q-mt-xs" v-model="tab" animated>
            <q-tab-panel class="q-pa-xs" name="divergence">
              <!-- This is Boucket -->
              <div v-if="rsiOrMacd == 'rsi'">
                <ListCardTableViewTradingView
                  :isStatusValid="false"
                  :indicators="['rsi']"
                  :tableTitle="'Rsi Divergence Status'"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="rsiDivergenceAlertDataComputed"
                  :sellData="rsiDivergenceSellAlertDataComputed"
                  :alertOrSignal="'alert'"
                />
              </div>
              <div v-if="rsiOrMacd == 'macd'">
                <ListCardTableViewTradingView
                  :isStatusValid="false"
                  :indicators="['macd']"
                  :tableTitle="'Macd Divergence Status'"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="macdDivergenceAlertDataComputed"
                  :sellData="macdDivergenceSellAlertDataComputed"
                  :alertOrSignal="'alert'"
                />
              </div>
            </q-tab-panel>

            <!-- Start of buy/sell divergence with price action -->
            <q-tab-panel class="q-pa-xs" name="divergenceWithPriceActionAlert">
              <div v-if="rsiOrMacd == 'rsi'">
                <!-- This is Alert with Price Action -->
                <ListCardTableViewTradingView
                  :tableTitle="'Rsi Divergence Alert Status'"
                  :indicators="['rsi']"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                  :alertOrSignal="'alert'"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="rsiDivergenceAlertPriceActionDataComputed"
                  :sellData="rsiDivergenceSellAlertPriceActionDataComputed"
                />
              </div>
              <div v-if="rsiOrMacd == 'macd'">
                <ListCardTableViewTradingView
                  :tableTitle="'Macd Divergence Alert Status'"
                  :indicators="['macd']"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                  :alertOrSignal="'alert'"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="macdDivergencePriceActionDataComputed"
                  :sellData="macdDivergenceSellPriceActionDataComputed"
                />
              </div>
            </q-tab-panel>
            <!-- End of  buy/sell divergence with price action -->

            <!-- Start of buy/sell divergence with price action signal -->
            <q-tab-panel class="q-pa-xs" name="divergenceWithPriceActionSignal">
              <div v-if="rsiOrMacd == 'rsi'">
                <ListCardTableViewTradingView
                  :tableTitle="'Rsi Divergence Signal Status'"
                  :indicators="['rsi']"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :alertOrSignal="'signal'"
                  :buyData="rsiDivergenceAlertPriceActionSignalDataComputed"
                  :sellData="
                    rsiDivergenceSellAlertPriceActionSignalDataComputed
                  "
                />
              </div>
              <div v-if="rsiOrMacd == 'macd'">
                <ListCardTableViewTradingView
                  :tableTitle="'Macd Divergence Signal Status'"
                  :indicators="['macd']"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :alertOrSignal="'signal'"
                  :buyData="macdDivergencePriceActionSignalDataComputed"
                  :sellData="macdDivergenceSellPriceActionSignalDataComputed"
                />
              </div>
            </q-tab-panel>
            <!-- end of  buy/sell divergence with price action signal -->

            <!-- ........................................................................................................... -->
            <!-- Start of buy/sell Hidden -->
            <q-tab-panel class="q-pa-xs" name="divergenceHidden">
              <div v-if="rsiOrMacd == 'rsi'">
                <ListCardTableViewTradingView
                  :isStatusValid="false"
                  :indicators="['rsi']"
                  :tableTitle="'Rsi Divergence Status'"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="rsiDivergenceAlertHiddenDataComputed"
                  :sellData="rsiDivergenceSellAlertHiddenDataComputed"
                />
              </div>
              <div v-if="rsiOrMacd == 'macd'">
                <ListCardTableViewTradingView
                  :isStatusValid="false"
                  :indicators="['macd']"
                  :tableTitle="'Macd Divergence Status'"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="macdDivergenceAlertHiddenDataComputed"
                  :sellData="macdDivergenceSellAlertHiddenDataComputed"
                />
              </div>
            </q-tab-panel>

            <q-tab-panel
              class="q-pa-xs"
              name="divergenceWithPriceActionAlertHidden"
            >
              <div v-if="rsiOrMacd == 'rsi'">
                <ListCardTableViewTradingView
                  :tableTitle="'Rsi Divergence Alert Status'"
                  :indicators="['rsi']"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                  :alertOrSignal="'alert'"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="rsiDivergenceAlertPriceActionHiddenDataComputed"
                  :sellData="
                    rsiDivergenceSellAlertPriceActionHiddenDataComputed
                  "
                />
              </div>
              <div v-if="rsiOrMacd == 'macd'">
                <ListCardTableViewTradingView
                  :tableTitle="'Macd Divergence Alert Status'"
                  :indicators="['macd']"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                  :alertOrSignal="'alert'"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="macdDivergencePriceActionHiddenDataComputed"
                  :sellData="macdDivergenceSellPriceActionHiddenDataComputed"
                />
              </div>
            </q-tab-panel>
            <q-tab-panel
              class="q-pa-xs"
              name="divergenceWithPriceActionSignalHidden"
            >
              <div v-if="rsiOrMacd == 'rsi'">
                <ListCardTableViewTradingView
                  :tableTitle="'Rsi Divergence Signal Status'"
                  :indicators="['rsi']"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                  :alertOrSignal="'signal'"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="rsiDivergencePriceActionSignalHiddenDataComputed"
                  :sellData="
                    rsiDivergenceSellPriceActionSignalHiddenDataComputed
                  "
                />
              </div>
              <div v-if="rsiOrMacd == 'macd'">
                <ListCardTableViewTradingView
                  :tableTitle="'Macd Divergence Signal Status'"
                  :indicators="['macd']"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                  :alertOrSignal="'signal'"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="macdDivergenceSignalPriceActionHiddenDataComputed"
                  :sellData="
                    macdDivergenceSellSignalPriceActionHiddenDataComputed
                  "
                />
              </div>
            </q-tab-panel>
            <!-- end of buy/sell Hidden -->
            <!-- ............................................................................................................ -->
          </q-tab-panels>
        </q-card>
      </div>
      <div v-else>
        <MessageCard
          :displayMessage="'This feature is exclusive to Platinum. Kindly subscribe to access it.'"
          :buttonText="'Subscribe Now'"
          :buttonRoute="'/payment'"
        />
      </div>
    </div>
  </q-card>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import { LocalStorage, useQuasar } from "quasar";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import useCore from "src/use/core";
import useData from "src/use/data";
import useMembership from "src/use/membership";
import MessageCard from "src/components/MessageCard.vue";
import ListCardTableViewTradingView from "src/components/TradingSignalsAndType/StockWiseListCardTableViewTradingView.vue";

import HelpComponent from "src/components/Help/HelpComponent.vue";

const $q = useQuasar();
const $route = useRoute();
const store = useStore();
const rsiDivergenceSellAlertPriceActionData = ref([]);
const { allStock } = useCore();
const {
  macdDivergenceAlert,
  macdDivergenceSellAlert,
  macdDivergencePriceAction,
  macdDivergenceSellPriceAction,
  macdDivergencePriceActionSignal,
  macdDivergenceSellPriceActionSignal,
  macdDivergenceAlertHidden,
  macdDivergencePriceActionHidden,
  macdDivergencePriceActionSignalHidden,

  rsiDivergenceAlertSell,
  rsiDivergenceAlert,
  rsiDivergenceHiddenAlert,
  rsiDivergenceHiddenAlertSell,
  rsiDivergenceAlertDailyWithPriceAction,
  rsiDivergenceSellAlertDailyWithPriceAction,
  rsiDivergenceAlertDailyWithPriceActionSignal,
  rsiDivergenceSellAlertDailyWithPriceActionSignal,
  rsiDivergenceAlertDailyWithPriceActionHidden,
  rsiDivergenceSellAlertDailyWithPriceActionHidden,
  rsiDivergenceAlertDailyWithPriceActionSignalHidden,
  rsiDivergenceSellAlertDailyWithPriceActionSignalHidden,
} = useData();

const props = defineProps({
  symbol: {
    type: String,
  },
});

const { getPackage, getPackageStatus } = useMembership();

const packageDetail = ref({});
const myStockList = ref([]);
const rsiDivergenceAlertHiddenData = ref([]);
const rsiDivergenceSellAlertHiddenData = ref([]);
const rsiDivergenceAlertPriceActionData = ref([]);
const rsiDivergenceSellAlertData = ref([]);
const rsiDivergenceAlertData = ref([]);
const rsiDivergenceAlertPriceActionSignalData = ref([]);
const rsiDivergenceSellAlertPriceActionSignalData = ref([]);
const rsiDivergenceAlertPriceActionHiddenData = ref([]);
const rsiDivergenceSellAlertPriceActionHiddenData = ref([]);
const rsiDivergenceSellAlertPriceActionSignalHiddenData = ref([]);
const rsiDivergencePriceActionSignalHiddenData = ref("");
const rsiDivergenceSellPriceActionSignalHiddenData = ref("");
const macdDivergenceSignalPriceActionHiddenData = ref("");
const macdDivergenceSellSignalPriceActionHiddenData = ref([]);

const macdDivergenceAlertData = ref([]);
const macdDivergenceSellAlertData = ref([]);
const macdDivergencePriceActionData = ref([]);
const macdDivergenceSellPriceActionData = ref([]);
const macdDivergencePriceActionSignalData = ref([]);
const macdDivergenceSellPriceActionSignalData = ref([]);
const macdDivergenceAlertHiddenData = ref([]);
const macdDivergenceSellAlertHiddenData = ref([]);
const macdDivergencePriceActionHiddenData = ref([]);
const macdDivergenceSellPriceActionHiddenData = ref([]);
const macdDivergencePriceActionSignalHiddenData = ref([]);
const macdDivergenceSellPriceActionSignalHiddenData = ref([]);

let timePeriod = ref("daily");
timePeriod.value = ref($route.query?.t || "daily")._value;

let rsiOrMacd = ref("ema");
rsiOrMacd.value = ref($route.query?.i || "rsi")._value;

let buttonBuyOrSell = ref("buy");
buttonBuyOrSell.value = ref($route.query?.s || "buy")._value;

let divergenceOrHiddenDivergence = ref("divergence");
divergenceOrHiddenDivergence.value = ref(
  $route.query?.d || "divergence"
)._value;

let tab = ref($route.query?.type || "divergenceWithPriceActionAlert");
tab.value = ref($route.query?.type || "divergenceWithPriceActionAlert")._value;

const isExtraPermissions = ref(false);
const isFeatureAvilable = ref(false);
const packageDetailStatus = ref({});

const loading = ref(true);

const selectedSymbol = ref(null);

getPackageStatus().then((res) => {
  packageDetailStatus.value = res.data;
  isExtraPermissions.value =
    res.data?.extra_permissions?.includes("DIVERGENCE_SIGNAL") || false;

  isFeatureAvilable.value =
    res.data.current_package.features?.includes("is_divergence_signal") ||
    false;
});

const allStocks = ref([]);

const bullishOrBearish = computed(() => {
  if (buttonBuyOrSell.value == "buy") {
    return "Bullish";
  } else {
    return "Bearish";
  }
});

allStock().then((res) => {
  allStocks.value = res.data;
});

if (store.state.authenticate.isAuthenticated) {
  if (LocalStorage.getItem("package") != null) {
    packageDetail.value = LocalStorage.getItem("package");
    myStockList.value = packageDetail.value.stocks;
  } else {
    getPackage()
      .then((res) => {
        packageDetail.value = res.data;
        myStockList.value = res.data;

        loading.value = false;
      })
      .catch((err) => {
        packageDetail.value = null;
      });
  }
}

macdDivergenceAlert(365).then((res) => {
  macdDivergenceAlertData.value = res.data;
});
macdDivergenceSellAlert(365).then((res) => {
  macdDivergenceSellAlertData.value = res.data;
});
macdDivergencePriceAction(365).then((res) => {
  macdDivergencePriceActionData.value = res.data;
});
macdDivergenceSellPriceAction(365).then((res) => {
  macdDivergenceSellPriceActionData.value = res.data;
});
macdDivergencePriceActionSignal(365).then((res) => {
  macdDivergencePriceActionSignalData.value = res.data;
});
macdDivergenceSellPriceActionSignal(365).then((res) => {
  macdDivergenceSellPriceActionSignalData.value = res.data;
});
macdDivergenceAlertHidden(365).then((res) => {
  macdDivergenceAlertHiddenData.value = res.data;
});
macdDivergencePriceActionSignal(365).then((res) => {
  macdDivergenceSellAlertHiddenData.value = res.data;
});
macdDivergencePriceActionHidden(365).then((res) => {
  macdDivergencePriceActionHiddenData.value = res.data;
});
macdDivergencePriceActionSignal(365).then((res) => {
  macdDivergenceSellPriceActionHiddenData.value = res.data;
});
macdDivergencePriceActionSignalHidden(365).then((res) => {
  macdDivergencePriceActionSignalHiddenData.value = res.data;
});
macdDivergencePriceActionSignal(365).then((res) => {
  macdDivergenceSellPriceActionSignalHiddenData.value = res.data;
});

rsiDivergenceAlert(365)
  .then((res) => {
    rsiDivergenceAlertData.value = res.data;
    loading.value = false;
  })
  .catch((error) => {
    console.log(error);
  });

rsiDivergenceAlertSell(365)
  .then((res) => {
    rsiDivergenceSellAlertData.value = res.data;
    loading.value = false;
  })
  .catch((error) => {
    console.log(error);
  });

rsiDivergenceAlertDailyWithPriceAction(365)
  .then((res) => {
    rsiDivergenceAlertPriceActionData.value = res.data;
  })
  .catch((error) => {
    console.log(error);
  });

rsiDivergenceSellAlertDailyWithPriceAction(365)
  .then((res) => {
    rsiDivergenceSellAlertPriceActionData.value = res.data;
  })
  .catch((error) => {
    console.log(error);
  });

rsiDivergenceAlertDailyWithPriceActionSignal(365)
  .then((res) => {
    rsiDivergenceAlertPriceActionSignalData.value = res.data;
  })
  .catch((error) => {
    console.log(error);
  });

rsiDivergenceSellAlertDailyWithPriceActionSignal(365)
  .then((res) => {
    rsiDivergenceSellAlertPriceActionSignalData.value = res.data;
  })
  .catch((error) => {
    console.log(error);
  });

rsiDivergenceHiddenAlert(365)
  .then((res) => {
    rsiDivergenceAlertHiddenData.value = res.data;
    loading.value = false;
  })
  .catch((error) => {
    console.log(error);
  });

rsiDivergenceHiddenAlertSell(365)
  .then((res) => {
    rsiDivergenceSellAlertHiddenData.value = res.data;
    loading.value = false;
  })
  .catch((error) => {
    console.log(error);
  });

rsiDivergenceAlertDailyWithPriceActionHidden(365)
  .then((res) => {
    rsiDivergenceAlertPriceActionHiddenData.value = res.data;
  })
  .catch((error) => {
    console.log(error);
  });

rsiDivergenceAlertDailyWithPriceActionSignalHidden(365)
  .then((res) => {
    rsiDivergencePriceActionSignalHiddenData.value = res.data;
  })
  .catch((error) => {
    console.log(error);
  });

rsiDivergenceSellAlertDailyWithPriceActionHidden(365)
  .then((res) => {})
  .catch((error) => {
    console.log(error);
  });

rsiDivergenceSellAlertDailyWithPriceActionSignalHidden(365)
  .then((res) => {
    rsiDivergenceSellAlertPriceActionSignalHiddenData.value = res.data;
  })
  .catch((error) => {
    console.log(error);
  });

const createFilteredComputed = (dataRef) => {
  return computed(() =>
    dataRef.value.filter((item) => item.symbol === props.symbol)
  );
};

// Optimized computed properties
const rsiDivergenceAlertDataComputed = createFilteredComputed(
  rsiDivergenceAlertData
);
const rsiDivergenceSellAlertDataComputed = createFilteredComputed(
  rsiDivergenceSellAlertData
);

const macdDivergenceAlertDataComputed = createFilteredComputed(
  macdDivergenceAlertData
);
const macdDivergenceSellAlertDataComputed = createFilteredComputed(
  macdDivergenceSellAlertData
);

const rsiDivergenceAlertPriceActionDataComputed = createFilteredComputed(
  rsiDivergenceAlertPriceActionData
);
const rsiDivergenceSellAlertPriceActionDataComputed = createFilteredComputed(
  rsiDivergenceSellAlertPriceActionData
);

const macdDivergencePriceActionDataComputed = createFilteredComputed(
  macdDivergencePriceActionData
);
const macdDivergenceSellPriceActionDataComputed = createFilteredComputed(
  macdDivergenceSellPriceActionData
);

const rsiDivergenceAlertPriceActionSignalDataComputed = createFilteredComputed(
  rsiDivergenceAlertPriceActionSignalData
);
const rsiDivergenceSellAlertPriceActionSignalDataComputed =
  createFilteredComputed(rsiDivergenceSellAlertPriceActionSignalData);

const macdDivergencePriceActionSignalDataComputed = createFilteredComputed(
  macdDivergencePriceActionSignalData
);
const macdDivergenceSellPriceActionSignalDataComputed = createFilteredComputed(
  macdDivergenceSellPriceActionSignalData
);

const rsiDivergenceAlertHiddenDataComputed = createFilteredComputed(
  rsiDivergenceAlertHiddenData
);
const rsiDivergenceSellAlertHiddenDataComputed = createFilteredComputed(
  rsiDivergenceSellAlertHiddenData
);

const macdDivergenceAlertHiddenDataComputed = createFilteredComputed(
  macdDivergenceAlertHiddenData
);
const macdDivergenceSellAlertHiddenDataComputed = createFilteredComputed(
  macdDivergenceSellAlertHiddenData
);

const rsiDivergenceAlertPriceActionHiddenDataComputed = createFilteredComputed(
  rsiDivergenceAlertPriceActionHiddenData
);
const rsiDivergenceSellAlertPriceActionHiddenDataComputed =
  createFilteredComputed(rsiDivergenceSellAlertPriceActionHiddenData);

const macdDivergencePriceActionHiddenDataComputed = createFilteredComputed(
  macdDivergencePriceActionHiddenData
);
const macdDivergenceSellPriceActionHiddenDataComputed = createFilteredComputed(
  macdDivergenceSellPriceActionHiddenData
);

const rsiDivergencePriceActionSignalHiddenDataComputed = createFilteredComputed(
  rsiDivergencePriceActionSignalHiddenData
);
const rsiDivergenceSellPriceActionSignalHiddenDataComputed =
  createFilteredComputed(rsiDivergenceSellPriceActionSignalHiddenData);

const macdDivergenceSignalPriceActionHiddenDataComputed =
  createFilteredComputed(macdDivergenceSignalPriceActionHiddenData);
const macdDivergenceSellSignalPriceActionHiddenDataComputed =
  createFilteredComputed(macdDivergenceSellSignalPriceActionHiddenData);
</script>
